import { VehicleType } from "../../vehicle-type/VehicleType";

export default interface SchoolCarrierTransportOption {
  readonly vehicleType?: VehicleType | null;
  readonly registrationPlate?: string | null;
}

export const SchoolCarrierTransportOptionInital: SchoolCarrierTransportOption = {
  vehicleType: null,
  registrationPlate: null
};
